import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'app.containers.ReportIssueForm.title',
    defaultMessage: 'Reportar um problema',
  },
  selectTheIssue: {
    id: 'app.containers.ReportIssueForm.selectTheIssue',
    defaultMessage: 'Selecione o problema ou dificuldade encontrada para realizar a sessão de fotos:',
  },
  issueObservations: {
    id: 'app.containers.ReportIssueForm.issueObservations',
    defaultMessage: 'Observações sobre o problema (opcional)',
  },
  reportIssue: {
    id: 'app.containers.ReportIssueForm.reportIssue',
    defaultMessage: 'Reportar problema',
  },
  issueNotePlaceholder: {
    id: 'app.containers.ReportIssueForm.issueNotePlaceholder',
    defaultMessage: 'Insira suas observações aqui...',
  },
  noChosenIssue: {
    id: 'app.containers.ReportIssueForm.noChosenIssue',
    defaultMessage: 'Nenhum motivo selecionado',
  },
  selectAnIssuetoReport: {
    id: 'app.containers.ReportIssueForm.selectAnIssuetoReport',
    defaultMessage: 'Selecione um motivo para reportar',
  },
  confirm: {
    id: 'app.containers.ReportIssueForm.confirm',
    defaultMessage: 'Confirmar',
  },
  cancel: {
    id: 'app.containers.ReportIssueForm.cancel',
    defaultMessage: 'Cancelar',
  },
  reschedule: {
    id: 'app.containers.ReportIssueForm.reschedule',
    defaultMessage: 'Reagendar',
  },
  dontReschedule: {
    id: 'app.containers.ReportIssueForm.dontReschedule',
    defaultMessage: 'Não reagendar',
  },
  goBack: {
    id: 'app.containers.ReportIssueForm.goBack',
    defaultMessage: 'Voltar',
  },
  reportDialogTitle: {
    id: 'app.containers.ReportIssueForm.reportDialogTitle',
    defaultMessage: 'Quer mesmo reportar esse problema?',
  },
  reportDialogDescriptionReschedule: {
    id: 'app.containers.ReportIssueForm.reportDialogDescriptionReschedule',
    defaultMessage: 'Ao confirmar, essa sessão de fotos não vai mais estar disponível na sua agenda. ' +
      'Em seguida, a gente verifica e te avisa se é possível reagendá-la.',
  },
  reportDialogDescriptionKeepsOnAgenda: {
    id: 'app.containers.ReportIssueForm.reportDialogDescriptionKeepsOnAgenda',
    defaultMessage: 'Ao confirmar, a sessão fica na sua agenda por até 3 dias ' +
      'para você reagendá-la com o proprietário.',
  },
  reportedIssueReschedulableTitle: {
    id: 'app.containers.ReportIssueForm.reportedIssueReschedulableTitle',
    defaultMessage: 'Problema reportado. O proprietário quer reagendar a sessão?',
  },
  reportedIssueTitle: {
    id: 'app.containers.ReportIssueForm.reportedIssueTitle',
    defaultMessage: 'Problema reportado',
  },
  reportedIssueNotReschedulableTitle: {
    id: 'app.containers.ReportIssueForm.reportedIssueNotReschedulableTitle',
    defaultMessage: 'Problema reportado',
  },
  reportedIssueReschedulablaDescription: {
    id: 'app.containers.ReportIssueForm.reportedIssueReschedulablaDescription',
    defaultMessage: 'Se souber uma nova data em que o proprietário pode realizar a sessão, você pode reagendá-la.',
  },
  reportedIssueNotReschedulableDescription: {
    id: 'app.containers.ReportIssueForm.reportedIssueNotReschedulableDescription',
    defaultMessage: 'Essa sessão não pode ser reagendada agora. \n' +
      'Entraremos em contato com o proprietário e, se necessário, remarcaremos a sessão de fotos.',
  },
  reportError: {
    id: 'app.containers.ReportIssueForm.reportError',
    defaultMessage: 'Não foi possível reportar seu problema. Tente novamente mais tarde.',
  },
  gotIt: {
    id: 'app.containers.ReportIssueForm.gotIt',
    defaultMessage: 'OK, entendi',
  },
  Duplicado: {
    id: 'app.containers.ReportIssueForm.Duplicado',
    defaultMessage: 'Imóvel duplicado',
  },
  Alugado: {
    id: 'app.containers.ReportIssueForm.Alugado',
    defaultMessage: 'Imóvel já alugado ou vendido',
  },
  ForaDoPadrao: {
    id: 'app.containers.ReportIssueForm.ForaDoPadrao',
    defaultMessage: 'Fotos fora do padrão',
  },
  SemChaves: {
    id: 'app.containers.ReportIssueForm.SemChaves',
    defaultMessage: 'Chave não disponível',
  },
  SemAutorizacao: {
    id: 'app.containers.ReportIssueForm.SemAutorizacao',
    defaultMessage: 'Portaria não permite entrada',
  },
  SemContato: {
    id: 'app.containers.ReportIssueForm.SemContato',
    defaultMessage: 'Proprietário não respondeu',
  },
  ProprietarioCancelou: {
    id: 'app.containers.ReportIssueForm.ProprietarioCancelou',
    defaultMessage: 'Proprietário quer cancelar',
  },
  NaoCompareceu: {
    id: 'app.containers.ReportIssueForm.NaoCompareceu',
    defaultMessage: 'Proprietário não compareceu',
  },
  Reforma: {
    id: 'app.containers.ReportIssueForm.Reforma',
    defaultMessage: 'Imóvel em reforma ou obras',
  },
  IMPREVISTO_FOTOGRAFO: {
    id: 'app.containers.ReportIssueForm.IMPREVISTO_FOTOGRAFO',
    defaultMessage: 'Tive um imprevisto',
  },
  LOCALIZACAO_PERIGOSA: {
    id: 'app.containers.ReportIssueForm.LOCALIZACAO_PERIGOSA',
    defaultMessage: 'Imóvel em localização perigosa',
  },
  IMOVEL_COMERCIAL: {
    id: 'app.containers.ReportIssueForm.IMOVEL_COMERCIAL',
    defaultMessage: 'Imóvel comercial',
  },
  PROBLEMA_COM_ENDERECO: {
    id: 'app.containers.ReportIssueForm.PROBLEMA_COM_ENDERECO',
    defaultMessage: 'Endereço incompleto ou incorreto',
  },
  IMOVEL_EM_CONDICAO_INSEGURA: {
    id: 'app.containers.ReportIssueForm.IMOVEL_EM_CONDICAO_INSEGURA',
    defaultMessage: 'Imóvel em condição insegura/questionável',
  },
  IMOVEL_EM_CONDICAO_INSEGURA_description: {
    id: 'app.containers.ReportIssueForm.IMOVEL_EM_CONDICAO_INSEGURA_description',
    defaultMessage: 'Imóvel inabitável/abandonado/bagunçado',
  },
  PROBLEMAS_NO_ENVIO_DE_FOTOS: {
    id: 'app.containers.ReportIssueForm.PROBLEMAS_NO_ENVIO_DE_FOTOS',
    defaultMessage: 'Proprietário não consegue enviar as fotos',
  },
  successfulRescheduling: {
    id: 'app.containers.ReportIssueForm.successfulRescheduling',
    defaultMessage: 'Reagendamos a sessão',
  },
  samePhotographerSelected: {
    id: 'app.containers.ReportIssueForm.samePhotographerSelected',
    defaultMessage: 'Você foi o fotógrafo selecionado para realizar essa sessão!',
  },
  lastRescheduleSamePhotographerSelected: {
    id: 'app.containers.ReportIssueForm.lastRescheduleSamePhotographerSelected',
    defaultMessage: 'Não havia outro fotógrafo disponível no horário, por isso a sessão permaneceu com você.',
  },
  differentPhotographerSelected: {
    id: 'app.containers.ReportIssueForm.differentPhotographerSelected',
    defaultMessage: 'Essa sessão de fotos foi direcionada para outro fotógrafo.',
  },
  samePhotographerDescription: {
    id: 'app.containers.ReportIssueForm.samePhotographerDescription',
    defaultMessage: 'O proprietário também vai ser notificado sobre a nova data. ' +
      'É importante que você fique atento porque ele ainda pode escolher cancelá-la.',
  },
  differentPhotographerDescription: {
    id: 'app.containers.ReportIssueForm.differentPhotographerDescription',
    defaultMessage: 'O proprietário vai ser notificado sobre a nova data e ainda pode escolher cancelá-la.',
  },
  reasonsErrorTitle: {
    id: 'app.containers.ReportIssueForm.reasonsErrorTitle',
    defaultMessage: 'Não foi possível carregar os motivos',
  },
  reasonsEmptyTitle: {
    id: 'app.containers.ReportIssueForm.reasonsEmptyTitle',
    defaultMessage: 'Nenhum motivo disponível',
  },
  reasonsEmptySubtitle: {
    id: 'app.containers.ReportIssueForm.reasonsEmptySubtitle',
    defaultMessage: 'Não há motivos para este tipo de sessão. Fale com o suporte.',
  },
});
